import o from "./_ListCache.js";
import r from "./_stackClear.js";
import s from "./_stackDelete.js";
import p from "./_stackGet.js";
import c from "./_stackHas.js";
import i from "./_stackSet.js";
var k = o, m = r, _ = s, f = p, l = c, h = i;
function t(e) {
  var a = this.__data__ = new k(e);
  this.size = a.size;
}
t.prototype.clear = m;
t.prototype.delete = _;
t.prototype.get = f;
t.prototype.has = l;
t.prototype.set = h;
var u = t;
export {
  u as default
};
//# sourceMappingURL=_Stack.js.map
